import { useCallback } from 'react';
import moment from 'moment';

import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';
import { toFuture } from 'sections/utils/dates';

export const useSetSendDate: () => [moment.Moment, (sendDate?: moment.Moment) => void] = () => {
  const { state } = useCampaignEditorContext();
  const { dispatch } = useCampaignEditorContext();

  const setSendDate = useCallback(
    (sendDate?: moment.Moment) => {
      if (!sendDate) {
        dispatch({ type: 'SET_SEND_DATE', payload: undefined });
        return;
      }

      const updatedDate = toFuture(sendDate, 1, 'minute');

      dispatch({ type: 'SET_SEND_DATE', payload: updatedDate.toDate() });
    },
    [dispatch],
  );

  return [state?.campaign?.sendDate ? moment(state.campaign.sendDate) : undefined, setSendDate];
};
